<form [formGroup]="formGroup" (ngSubmit)="onFormSubmit()">
  <h4 class="text-center">Sign in with your Account</h4>
  <mat-form-field class="width-max email-form-field">
    <mat-label>Email</mat-label>
    <input formControlName="email" type="text" matInput placeholder="Type your email here" />
    <mat-error *ngIf="emailFormControl.hasError('required')">Required field</mat-error>
    <mat-error *ngIf="emailFormControl.hasError('email')">Field should have a correct email address</mat-error>
  </mat-form-field>
  <mat-form-field class="width-max password-form-field">
    <mat-label>Password</mat-label>
    <input formControlName="password" type="password" matInput placeholder="Type your password here" />
    <mat-error *ngIf="passwordFormControl.hasError('required')">Required field</mat-error>
    <mat-error *ngIf="passwordFormControl.hasError('minlength')">Password should be at least 8 characters</mat-error>
  </mat-form-field>
  <div class="sign-in-container">
    <button type="submit" [disabled]="!formGroup.valid" class="width-max" mat-raised-button color="primary">
      SIGN IN
    </button>
  </div>
</form>
